import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const statics = new Restful(project, 'static')
statics.download = function(fileName) {
  const url = project + 'static/' + fileName
  return http.octetget(url).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

const process = new Restful(project, 'import')
process.getProcess = function(type, id) {
  const url = project + 'import/progress/' + type + '/' + id
  return http.get(url).then(res => {
    return res
  })
}
export { statics, process }
export default statics
